import { X_OWA_AUTO_LINKS_CLASSNAME } from './constants';
import { OWA_AUTO_LINKS_CLASSNAME } from 'owa-compose-link';
import { format } from 'owa-strings';
import { trace } from 'owa-trace';
import { Editor } from 'roosterjs-editor-core';
import { AttachmentWellViewState, lazyCheckForRemovedLinks } from 'owa-attachment-well-data';

let checkForRemovedLinks;

export default async function getAllSharePointLinks(
    editor: Editor,
    viewState: AttachmentWellViewState
): Promise<void> {
    const existingLinkIdMap: { [key: string]: boolean } = {};
    getLinksBasedOnClassName(OWA_AUTO_LINKS_CLASSNAME, editor, existingLinkIdMap);
    getLinksBasedOnClassName(X_OWA_AUTO_LINKS_CLASSNAME, editor, existingLinkIdMap);

    if (!checkForRemovedLinks) {
        checkForRemovedLinks = await lazyCheckForRemovedLinks.import();
    }

    checkForRemovedLinks(viewState, existingLinkIdMap);
}

function getLinksBasedOnClassName(
    className: string,
    editor: Editor,
    existingLinkIdMap: { [key: string]: boolean }
) {
    const allSPLinks = editor.queryElements('.' + className, link => {
        existingLinkIdMap[link.id] = true;
    });

    trace.info(format('getLinksBasedOnClassName: Found {0} SP links.', allSPLinks.length));
}
